import GuardAuthenticationStatus from "hooks/GuardAuthenticationStatus";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import SendResetPassword from "ui/welcome/SendResetPassword";
import Login from "./Login";
import ResetPassword from "./ResetPassword";
import SignUp from "./SignUp";

const WelcomeRoot: React.FC = () => {
    GuardAuthenticationStatus("unauthenticated");

    return (
        <Switch>
            <Route exact={true} path="*/login">
                <Login />
            </Route>
            <Route exact={true} path="*/sign-up">
                <SignUp />
            </Route>
            <Route exact={true} path="*/reset-password">
                <ResetPassword />
            </Route>
            <Route exact={true} path="*/send-reset-password">
                <SendResetPassword />
            </Route>
            <Route path="*">
                <Redirect to="/welcome/login" />
            </Route>
        </Switch>
    );
};

export default WelcomeRoot;
